var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
export var useExpandNodesLogic = function (nodes, columns, startNodeId, nodesCollapsibleFromColumn, nodesExpandedFromColumn) {
    var _a = useState(nodes
        .filter(function (node) { return node.depth < nodesExpandedFromColumn; })
        .map(function (node) { return node.id; })), expandedNodeIds = _a[0], setExpandedNodeIds = _a[1];
    var isNodeExpandable = function (node, columnIndex) {
        return node.links.length > 0 && nodesCollapsibleFromColumn !== undefined && columnIndex >= nodesCollapsibleFromColumn;
    };
    var isNodeExpanded = function (nodeId) {
        return expandedNodeIds.includes(nodeId);
    };
    var isNodeUnlinked = function (nodeId, columnIndex) {
        if (columnIndex === 0) {
            return nodeId !== startNodeId;
        }
        else {
            var nodesInPreviousColumn = nodes.filter(function (node) { return columns[columnIndex - 1].includes(node.id); });
            return !nodesInPreviousColumn.find(function (columnNode) { return columnNode === null || columnNode === void 0 ? void 0 : columnNode.links.map(function (link) { return link.nodeId; }).includes(nodeId); });
        }
    };
    var onExpandNodeToggle = function (nodeId) {
        if (expandedNodeIds.includes(nodeId)) {
            setExpandedNodeIds(expandedNodeIds.filter(function (id) { return id !== nodeId; }));
        }
        else {
            setExpandedNodeIds(__spreadArray(__spreadArray([], expandedNodeIds, true), [nodeId], false));
        }
    };
    return {
        expandedNodeIds: expandedNodeIds,
        isNodeExpandable: isNodeExpandable,
        isNodeExpanded: isNodeExpanded,
        isNodeUnlinked: isNodeUnlinked,
        onExpandNodeToggle: onExpandNodeToggle
    };
};
//# sourceMappingURL=expandNodes.js.map